import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../../Core/RichText';
import ProductIconText from '../../../Optimum/OptimumProductCards/ProductIconText';

import {
  Block,
  Content,
  EligibilitySection,
  ImageWrapper,
  Img,
  SectionTitle,
  SectionContent,
  Header,
  CardName,
} from './styles';

export const sectionTitle = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <SectionTitle>{children}</SectionTitle>
    ),
  },
};
export const sectionContent = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <SectionContent>{children}</SectionContent>
    ),
  },
};

const body = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => {
      return <>{children}</>;
    },
    [BLOCKS.EMBEDDED_ENTRY]: node => {
      const { data } = node;
      if (data.target.__typename === 'ContentfulTitleOrImageWithIconLists') {
        return (
          <ProductIconText data={data.target} className="card-comparison" />
        );
      }
      return null;
    },
  },
};

const CardDetails = ({ data, isOpen }) => {
  if (!data) return null;

  const { preHeading, heading, imageDam, bodyCopy, subhead } = data;

  return (
    <Block isOpen={isOpen}>
      <Header>
        {imageDam && (
          <ImageWrapper>
            <Img src={imageDam} alt={imageDam.altText || ''} />
          </ImageWrapper>
        )}
        <CardName>{preHeading && <RichText document={preHeading} />}</CardName>
      </Header>
      {subhead && (
        <EligibilitySection>
          {heading && <RichText document={heading} options={sectionTitle} />}
          {subhead && <RichText document={subhead} options={sectionContent} />}
        </EligibilitySection>
      )}
      <Content>
        {bodyCopy && <RichText document={bodyCopy} options={body} />}
      </Content>
    </Block>
  );
};

CardDetails.propTypes = {
  data: PropTypes.shape().isRequired,
  isOpen: PropTypes.bool,
};

export default CardDetails;
